import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { airportDataRequest, getAirportDataSuccess, getAirportDataFailure, getCityPairMappingAirportDataSuccess, getCityPairMappingAirportDataFailure } from "../slice/bookingWidgetSlice";
import { config } from "../../../config/global";
import i18n from "../../../i18n";
const AIRPORT_API_URL = config?.AIRPORT_MAIN_URL;
const CITY_PAIR_MAPPING_AIRPORT_URL = config?.CITY_PAIR_MAPPING_AIRPORT;
function* getAirportData(action) {
  const lang = i18n?.language?.split("-")?.[0];
  try {
    const data = {
      mode: "no-cors",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": lang
      },
      body: {}
    };
    const response = yield call(api.get, `${AIRPORT_API_URL}?lang=${lang}&filter_by=active`, data);
    yield put(getAirportDataSuccess(response.data));
  } catch (error) {
    yield put(getAirportDataFailure(error.message));
  }
}
function* getCityPairMappingAirportData(action) {
  try {
    let data = {
      mode: "no-cors",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": i18n.language == "th-th" ? "th" : i18n.language === "zh-tw" || i18n.language === "zh-hk" ? "tw" : action.payload
      },
      body: {}
    };
    const response = yield call(api.get, CITY_PAIR_MAPPING_AIRPORT_URL, data);
    yield put(getCityPairMappingAirportDataSuccess(response?.data));
  } catch (error) {
    yield put(getCityPairMappingAirportDataFailure(error?.message));
  }
}
export function* watchAirportData() {
  yield takeLatest(airportDataRequest.type, getAirportData);
}
export function* watchCityPairMappingAirportData() {
  yield takeLatest(airportDataRequest.type, getCityPairMappingAirportData);
}